import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import App from "./App";
import { reportError } from "@/app/_utils/reportError";
import { initGa4 } from "@/app/_utils/ga4";
import "@/app/globals.scss";
import "@/app/_styles/cuo.scss";
import "@/app/_styles/fullCalendar.scss";

window.addEventListener("unhandledrejection", (event) => {
  const error =
    event.reason instanceof Error
      ? event.reason
      : new Error(String(event.reason));
  reportError(error, "unhandledrejection");
});

initGa4();

posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
  api_host:          import.meta.env.VITE_POSTHOG_HOST,
  capture_pageview:  false,  // handled manually in App.tsx via PostHogPageView
  capture_pageleave: true,
  autocapture:       false,
  persistence:       "localStorage",
  person_profiles:   "always",  // create a profile from first pageview so funnels track anonymous → identified
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </PostHogProvider>
  </React.StrictMode>
);
